/*
 * Copyright (c) 2024. Haodong JU
 */

import dayjs from 'dayjs'
import { timestampTemplate } from '@/model/utils/reservationUtils'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import { hillo } from 'hillo'
import { reservationLocalHost } from '@/model/dataLayer/api/newReservation/reservation'

const host = reservationLocalHost + '/reservation/'
const todayEnd = dayjs().startOf('d')
  .add(1, 'd').add('3', 'h')
  .add(59, 'm').format(timestampTemplate)

export async function getCurrentReservation () {
  const nowMinus30 = dayjs().subtract(60, 'm').format(timestampTemplate)

  return (await loadAllReservation(nowMinus30, todayEnd)).filter(it => it.status === 'Confirmed')
}

export async function loadAllReservation (fromDateTime, toDateTime) {
  const deviceId = parseInt(await getCurrentDeviceId())
  return (await hillo.get(host + 'getList/' + deviceId,
    {
      fromDateTime,
      toDateTime
    })).data
}
